const xcsrfToken = () => document.querySelector('meta[name="csrf-token"]').content;

const clearErrorMessages = () => {
  $('#verification-code-missing').addClass('hidden');
  $('#verification-code-error').addClass('hidden')
  $("#verification-code-error-message").text('');
}

const resetForm = () => {
  $('[name="verification_code"]').val('');
  $('.loading-overlay').addClass('hidden');
  $('.btn.overlay-form').prop('disabled', false);
  $('form').trigger('reset'); // Clear all form fields on the page
  document.getElementById('register-button').disabled = true;  // Disable the register button
}

const closeVerificationCodeModal = () => {
  clearErrorMessages();
  $('#verificationCodeModal').modal('hide');
}

$(document).on('click', '.overlay-form', function(){
  $('#new-registration-loader > .loading-overlay').removeClass('hidden');
  const email = document.querySelector('[name="email"]') && document.querySelector('[name="email"]').value;
  if(email) {
    document.getElementById('email-display').textContent = email;
    sendRegistrationRequest(email);
  }
});

$(document).on('click', '.hide-overlay-form', function(){
  $('.loading-overlay').addClass('hidden');
});

let intervalId = null;
let countdownActive = false;

$(document).on('click', '#verification-code-modal-close', function(){
  resetForm();
  closeVerificationCodeModal();
  let html = `
    <div class="flash flash-error d-flex align-items-center alert flash_padding" role="alert">
      <div class="flash-left"><i aria-hidden="true" class="icon-error large"></i></div>
      <div class="flash-right"><strong>Error</strong><br>Account with provided email was not created</div>
      <a href="#" data-dismiss="alert" class="alert-dismiss">DISMISS</a>
    <div class="clearfix"></div></div>
  `;
  $(".js-flash").prepend(html);

  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
  countdownActive = false;
  const link = document.getElementById('resend-verification-link');
  const timer = document.getElementById('countdown-timer');
  link.classList.remove('disabled');
  link.style.pointerEvents = 'auto';
  timer.textContent = '';
});

$(document).on('click', '#verify-email-submit', (e) => {
  clearErrorMessages()
  const codeInput = $('[name="verification_code"]');

  if( codeInput.val().trim() === '') {
    $('#verification-code-missing').removeClass('hidden');
    return;
  }

  $('#verification-code-missing').addClass('hidden');
  $('#verify-email-submit').prop('disabled', true);
  $('#email-verification-spinner').css('display', 'inline-block');
  const emailInput = $('[name="email"]');
  const passwordInput = $('[name="password"]');

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-Token': xcsrfToken()
  };

  const body = JSON.stringify({
    verification_code: codeInput.val().trim(),
    email: emailInput.val(),
    password: passwordInput.val(),
  })

  fetch('/verify_email', { method: 'POST', headers, body }).then(
    (response) => {
      if (response.ok) {
        closeVerificationCodeModal();
        $('#verification-code-modal-success').modal('show');

        response.json().then(
          data => {
            $("#continue-registration-button").on("click", () => window.location = data.redirect_url)
            $("#verification-code-modal-success-close").on("click", () => window.location = data.redirect_url)
          }
        )
      } else if (response.status === 400) {
        response.json().then(
          data => {
            resetForm();
            closeVerificationCodeModal();
            let html = `
              <div class="flash flash-error d-flex align-items-center alert flash_padding" role="alert">
                <div class="flash-left"><i aria-hidden="true" class="icon-error large"></i></div>
                <div class="flash-right"><strong>Error</strong><br>${data.error}</div>
                <a href="#" data-dismiss="alert" class="alert-dismiss">DISMISS</a>
              <div class="clearfix"></div></div>
            `;
            $(".js-flash").prepend(html);
          }
        );
      } else {
        response.json().then(
          data => {
            $("#verification-code-error-message").text(data.error);
            $('#verification-code-error').removeClass('hidden')
            $('#verify-email-submit').prop('disabled', false);
            $('#email-verification-spinner').css('display', 'none');
          }
        )
      }
    }
  );
});

$(document).on('click', '#resend-verification-link', function(event) {
  event.preventDefault();
  this.classList.add('disabled');
  const email = document.querySelector('[name="email"]').value;

  sendRegistrationRequest(email, function() {
    $('#resend-tooltip')
      .removeClass('hidden')
      .fadeIn()
      .delay(15000)
      .fadeOut();

    startCountdownTimer();
  });
});


function startCountdownTimer() {
  if (countdownActive) return;

  countdownActive = true;
  const verifyLink = document.getElementById("resend-verification-link");
  const countdownTimer = document.getElementById("countdown-timer");
  const totalSeconds = 90;

  if (!verifyLink || !countdownTimer) return;

  verifyLink.classList.add('disabled');
  verifyLink.style.pointerEvents = 'none';
  let secondsLeft = totalSeconds;

  countdownTimer.textContent = `Resend link available in ${secondsLeft}s`;

  intervalId = setInterval(() => {
    secondsLeft--;

    if (secondsLeft > 0) {
      countdownTimer.textContent = `Resend link available in ${secondsLeft}s`;
    } else {
      clearInterval(intervalId);
      countdownTimer.textContent = '';
      verifyLink.classList.remove('disabled');
      verifyLink.style.pointerEvents = 'auto';
      countdownActive = false;
    }
  }, 1000);
}

function sendRegistrationRequest(email, onSuccess) {
  fetch('/user_registration', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': xcsrfToken()
    },
    body: JSON.stringify({ email: email })
  })
    .then(response => {
      if (response.ok) {
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
        else {
          $("#register-button").attr('disabled', true);
          $('.loading-overlay').removeClass('hidden');
          $('#verificationCodeModal').modal('show');
        }
      } else if (response.status === 429) {
        // PURPLE-8259: Rate-limited responses use a different body shape
        // ({ error: "..." }) than validation errors ({ errors: { email: ... } }),
        // so handle them explicitly to avoid rendering "undefined".
        response.json().then(data => {
          const message = (data && data.error) || 'Too many attempts. Please try again later.';
          let html = `
            <div class="flash flash-error d-flex align-items-center alert flash_padding" role="alert">
              <div class="flash-left"><i aria-hidden="true" class="icon-error large"></i></div>
              <div class="flash-right"><strong>Error</strong><br>${message}</div>
              <a href="#" data-dismiss="alert" class="alert-dismiss">DISMISS</a>
            <div class="clearfix"></div></div>
          `;
          $(".js-flash").prepend(html);
          $('.loading-overlay').addClass('hidden');
        });
      } else {
        response.json().then(data => {
          let html = `
            <div class="flash flash-error d-flex align-items-center alert flash_padding" role="alert">
              <div class="flash-left"><i aria-hidden="true" class="icon-error large"></i></div>
              <div class="flash-right"><strong>Error</strong><br>${data.errors.email}</div>
              <a href="#" data-dismiss="alert" class="alert-dismiss">DISMISS</a>
            <div class="clearfix"></div></div>
          `;
          $(".js-flash").prepend(html);
        })
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('An error occurred. Please try again.');
    });
}

function validate_password(password) {
  const password_min_length = Number(document.getElementById('password').getAttribute('data-password-min-length'));
  if (!password) {
    return false;
  }
  // Only require a numeral if the element with class 'numeral-js' is present
  const requireNumeral = document.querySelector('.numeral-js') !== null;

  return password.length >= password_min_length &&
    password.length <= 72 &&
    password.match(/[A-Z]/) &&
    password.match(/[a-z]/) &&
    password.replace(/\s/g, '').match(/\W/) &&
    (requireNumeral ? password.match(/\d/) : true);
};


document.addEventListener('input', function () {
  const email = document.querySelector('[name="email"]') && document.querySelector('[name="email"]').value;
  const emailConfirmation = document.querySelector('[name="email_confirmation"]') && document.querySelector('[name="email_confirmation"]').value;
  const password = document.querySelector('[name="password"]') && document.querySelector('[name="password"]').value;
  const passwordConfirmation = document.querySelector('[name="password_confirmation"]') && document.querySelector('[name="password_confirmation"]').value;

  const isFormComplete =
    email &&
    emailConfirmation &&
    password &&
    passwordConfirmation &&
    email === emailConfirmation &&
    password === passwordConfirmation
    && validate_password(password);

  const registerButton = document.getElementById('register-button');
  if (registerButton) {
    registerButton.disabled = !isFormComplete;
  }
});

// Hide loading overlay when page loads (in case it was left visible)
$(document).ready(function() {
  $('.loading-overlay').addClass('hidden');
});

// Hide loading overlay on form submission errors or completion
$(document).on('ajax:error ajax:complete', 'form', function() {
  $('.loading-overlay').addClass('hidden');
});
